import { get } from '../utils/httpInterceptor';
import { buildCrudQueryParams } from './filterQueryBuilder';

class CurrencyService {
  static async getAll(page, size, filters = {}, sortConfig = {}) {
    const queryParams = buildCrudQueryParams({
      page,
      size,
      filters,
      sortConfig,
      sortMode: 'split',
    });
    return await get(`/currency?${queryParams.toString()}`);
  }
}

export default CurrencyService;
